"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.array.index-of.js");
var _utils = require("./utils");
var _scroll = require("../utils/scroll");
var _event = require("../utils/event");
var _utils2 = require("../utils");
var _icon = _interopRequireDefault(require("../icon"));
var _cell = _interopRequireDefault(require("../cell"));
var _shared = require("../cell/shared");
// Utils

// Components

var _use = (0, _utils2.use)('field'),
  sfc = _use[0],
  bem = _use[1];
var _default = sfc({
  inheritAttrs: false,
  provide: function provide() {
    return {
      zzField: this
    };
  },
  inject: {
    zzForm: {
      default: null
    }
  },
  props: Object.assign({}, _shared.cellProps, {
    darkBg: Boolean,
    name: String,
    rules: Array,
    error: Boolean,
    leftIcon: String,
    rightIcon: String,
    leftIconZziconfont: Boolean,
    // 兼容旧写法
    leftIconClassPrefix: String,
    rightIconZziconfont: Boolean,
    // 兼容旧写法
    rightIconClassPrefix: String,
    useNumberKeyboard: Boolean,
    readonly: Boolean,
    clearable: Boolean,
    labelWidth: [Number, String],
    maxlength: [Number, String],
    labelAlign: String,
    labelClass: null,
    inputAlign: String,
    onIconClick: Function,
    autosize: [Boolean, Object],
    countWord: Boolean,
    errorMessage: String,
    errorMessageAlign: String,
    type: {
      type: String,
      default: 'text'
    },
    openComposing: {
      type: Boolean,
      default: true
    }
  }),
  data: function data() {
    return {
      focused: false,
      validateMessage: '',
      isComposing: false // 输入中文的过程不触发 input 事件
    };
  },

  watch: {
    value: function value(_value) {
      this.resetValidation();
      this.validateWithTrigger('onChange');
      this.$nextTick(this.adjustSize);

      // format maxlength
      if (this.useNumberKeyboard) {
        var formatedValue = this.format();
        if (_value !== formatedValue) {
          this.$emit('input', formatedValue);
        }
      }
    }
  },
  mounted: function mounted() {
    this.format();
    this.$nextTick(this.adjustSize);
    if (this.zzForm) {
      this.zzForm.addField(this);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.zzForm) {
      this.zzForm.removeField(this);
    }
  },
  computed: {
    showClear: function showClear() {
      return this.clearable && this.focused && this.value !== '' && (0, _utils2.isDef)(this.value) && !this.readonly;
    },
    showError: function showError() {
      if (this.zzForm && this.zzForm.showError && this.validateMessage) {
        return true;
      }
      return this.error;
    },
    listeners: function listeners() {
      var listeners = Object.assign({}, this.$listeners, {
        input: this.onInput,
        keypress: this.onKeypress,
        focus: this.onFocus,
        blur: this.onBlur,
        compositionstart: this.onCompositionstart,
        compositionend: this.onCompositionend
      });
      delete listeners.click;
      return listeners;
    },
    disabled: function disabled() {
      // input attribute fix
      return this.$attrs.disabled || this.$attrs.disabled === '';
    },
    countingWord: function countingWord() {
      if (!this.maxlength || !this.countWord) {
        return false;
      }
      var total = this.value && this.value.length || 0;
      var max = +this.maxlength;
      return {
        total: total,
        max: max,
        exceeded: total > max
      };
    },
    formValue: function formValue() {
      if (this.children && (this.$scopedSlots.input || this.$slots.input)) {
        return this.children.value;
      }
      return this.value;
    }
  },
  methods: {
    // @exposed-api
    focus: function focus() {
      if (this.$refs.input) {
        this.$refs.input.focus();
      }
    },
    // @exposed-api
    blur: function blur() {
      if (this.$refs.input) {
        this.$refs.input.blur();
      }
    },
    runValidator: function runValidator(value, rule) {
      return new Promise(function (resolve) {
        var returnVal = rule.validator(value, rule);
        if ((0, _utils2.isPromise)(returnVal)) {
          return returnVal.then(resolve);
        }
        resolve(returnVal);
      });
    },
    isEmptyValue: function isEmptyValue(value) {
      if (Array.isArray(value)) {
        return !value.length;
      }
      return !value;
    },
    runSyncRule: function runSyncRule(value, rule) {
      if (rule.required && this.isEmptyValue(value)) {
        return false;
      }
      if (rule.pattern && !rule.pattern.test(value)) {
        return false;
      }
      return true;
    },
    getRuleMessage: function getRuleMessage(value, rule) {
      var message = rule.message;
      if ((0, _utils2.isFunction)(message)) {
        return message(value, rule);
      }
      return message;
    },
    runRules: function runRules(rules) {
      var _this = this;
      return rules.reduce(function (promise, rule) {
        return promise.then(function () {
          if (_this.validateMessage) {
            return;
          }
          var value = _this.formValue;
          if (rule.formatter) {
            value = rule.formatter(value, rule);
          }
          if (!_this.runSyncRule(value, rule)) {
            _this.validateMessage = _this.getRuleMessage(value, rule);
            return;
          }
          if (rule.validator) {
            return _this.runValidator(value, rule).then(function (result) {
              if (result === false) {
                _this.validateMessage = _this.getRuleMessage(value, rule);
              }
            });
          }
        });
      }, Promise.resolve());
    },
    validate: function validate(rules) {
      var _this2 = this;
      if (rules === void 0) {
        rules = this.rules;
      }
      return new Promise(function (resolve) {
        if (!rules) {
          resolve();
        }
        _this2.runRules(rules).then(function () {
          if (_this2.validateMessage) {
            resolve({
              name: _this2.name,
              message: _this2.validateMessage
            });
          } else {
            resolve();
          }
        });
      });
    },
    validateWithTrigger: function validateWithTrigger(trigger) {
      if (this.zzForm && this.rules) {
        var defaultTrigger = this.zzForm.validateTrigger === trigger;
        var rules = this.rules.filter(function (rule) {
          if (rule.trigger) {
            return rule.trigger === trigger;
          }
          return defaultTrigger;
        });
        this.validate(rules);
      }
    },
    resetValidation: function resetValidation() {
      if (this.validateMessage) {
        this.validateMessage = '';
      }
    },
    format: function format(target) {
      if (target === void 0) {
        target = this.$refs.input;
      }
      if (!target) {
        return;
      }
      var value = this.useNumberKeyboard ? this.value : target.value;
      var maxlength = this.maxlength;

      // native maxlength not work when type is number
      if ((0, _utils2.isDef)(maxlength) && value.length > maxlength) {
        value = value.slice(0, maxlength);
        if (!this.useNumberKeyboard) {
          target.value = value;
        }
      }
      if (!this.useNumberKeyboard && (this.type === 'number' || this.type === 'digit')) {
        var originValue = value;
        var allowDot = this.type === 'number';
        value = (0, _utils.formatNumber)(value, allowDot);
        if (value !== originValue) {
          target.value = value;
        }
      }
      return value;
    },
    onInput: function onInput(event) {
      if (this.isComposing && this.openComposing) return;
      this.$emit('input', this.format(event.target));
    },
    onCompositionstart: function onCompositionstart(event) {
      if (!this.openComposing) return;
      this.isComposing = true;
    },
    onCompositionend: function onCompositionend(event) {
      if (!this.openComposing) return;
      this.isComposing = false;
      this.onInput(event);
    },
    onNKFocus: function onNKFocus(event) {
      if (!this.disabled && !this.readonly) {
        this.onFocus(event);
      }
    },
    onNKBlur: function onNKBlur(event) {
      if (!this.disabled && !this.readonly) {
        this.onBlur(event);
      }
    },
    onFocus: function onFocus(event) {
      this.focused = true;
      this.$emit('focus', event);

      // Android do not scroll into view by default
      if (_utils2.isAndroid && this.$refs.input) {
        try {
          this.$refs.input.scrollIntoViewIfNeeded();
        } catch (error) {
          console.log(error);
        }
      }

      // readonly not work in lagacy mobile safari
      if (this.readonly) {
        this.blur();
      }
    },
    onBlur: function onBlur(event) {
      this.focused = false;
      this.$emit('blur', event);
      this.validateWithTrigger('onBlur');
      // 修复iOS的页面滚动问题
      (0, _scroll.pageScrollFix)();
    },
    onClick: function onClick(event) {
      if (!this.disabled) {
        this.$emit('click', event);
      }
    },
    onClickLeftIcon: function onClickLeftIcon(event) {
      if (!this.disabled) {
        this.$emit('click-left-icon', event);
      }
    },
    onClickRightIcon: function onClickRightIcon(event) {
      if (!this.disabled) {
        this.$emit('click-right-icon', event);
      }
    },
    onClear: function onClear(event) {
      (0, _event.preventDefault)(event, true);
      this.$emit('input', '');
      this.$emit('clear', event);
    },
    onKeypress: function onKeypress(event) {
      var keyCode = event.keyCode;
      if (this.type === 'number') {
        var allowPoint = String(this.value).indexOf('.') === -1;
        var isValidKey = keyCode >= 48 && keyCode <= 57 || keyCode === 46 && allowPoint || keyCode === 45 || keyCode === 13;
        if (!isValidKey) {
          event.preventDefault();
        }
      }

      // trigger blur after click keyboard search button
      /* istanbul ignore next */
      if (this.type === 'search' && keyCode === 13) {
        this.blur();
      }
      this.$emit('keypress', event);
    },
    adjustSize: function adjustSize() {
      var input = this.$refs.input;
      if (!(this.type === 'textarea' && this.autosize) || !input) {
        return;
      }
      input.style.height = 'auto';
      var height = input.scrollHeight;
      if ((0, _utils2.isObj)(this.autosize)) {
        var _this$autosize = this.autosize,
          maxHeight = _this$autosize.maxHeight,
          minHeight = _this$autosize.minHeight;
        if (maxHeight) {
          height = Math.min(height, maxHeight);
        }
        if (minHeight) {
          height = Math.max(height, minHeight);
        }
      }
      if (height) {
        input.style.height = height + 'px';
      }
    },
    genInput: function genInput() {
      var h = this.$createElement;
      var type = this.type,
        useNumberKeyboard = this.useNumberKeyboard;
      var inputSlot = this.slots('input');
      var inputAlign = this.getProp('inputAlign');
      if (inputSlot) {
        return h("div", {
          "class": bem('control', [inputAlign, 'custom'])
        }, [inputSlot]);
      }
      if (useNumberKeyboard) {
        return h("div", {
          "ref": "input",
          "attrs": {
            "tabindex": "0"
          },
          "class": bem('control', [inputAlign, 'custom', 'number-keyboard']),
          "on": {
            "focus": this.onNKFocus,
            "blur": this.onNKBlur
          }
        }, [h("span", {
          "class": ['value', 'z-ellipsis', this.focused && 'focused', this.disabled && 'disabled']
        }, [this.value]), h("span", {
          "class": ['placeholder', 'z-ellipsis', this.value && 'hide', this.disabled && 'disabled']
        }, [this.$attrs.placeholder])]);
      }
      var inputProps = {
        ref: 'input',
        class: [bem('control', this.inputAlign), this.type !== 'textarea' && 'z-ellipsis', this.darkBg ? this.type !== 'textarea' ? bem('darkbg-input') : bem('darkbg-textarea') : ''],
        domProps: {
          value: this.value
        },
        attrs: Object.assign({}, this.$attrs, {
          name: this.name,
          disabled: this.disabled,
          readonly: this.readonly
        }),
        on: this.listeners,
        // add model directive to skip IME composition
        directives: [{
          name: 'model',
          value: this.value
        }]
      };
      if (type === 'textarea') {
        return h("textarea", (0, _babelHelperVueJsxMergeProps.default)([{}, inputProps]));
      }
      var inputType = type;
      var inputMode;

      // type="number" is weired in iOS, and can't prevent dot in Android
      // so use inputmode to set keyboard in mordern browsers
      if (type === 'number') {
        inputType = 'text';
        inputMode = 'decimal';
      }
      if (type === 'digit') {
        inputType = 'tel';
        inputMode = 'numeric';
      }
      return h("input", (0, _babelHelperVueJsxMergeProps.default)([{
        "attrs": {
          "type": inputType,
          "inputmode": inputMode
        }
      }, inputProps]));
    },
    genLeftIcon: function genLeftIcon() {
      var h = this.$createElement;
      var showLeftIcon = this.slots('left-icon') || this.leftIcon;
      if (showLeftIcon) {
        return h("div", {
          "class": bem('left-icon'),
          "on": {
            "click": this.onClickLeftIcon
          }
        }, [this.slots('left-icon') || h(_icon.default, {
          "attrs": {
            "classPrefix": this.leftIconClassPrefix || (this.leftIconZziconfont ? 'zziconfont' : undefined),
            "name": this.leftIcon
          }
        })]);
      }
    },
    genRightIcon: function genRightIcon() {
      var h = this.$createElement;
      var showRightIcon = this.slots('right-icon') || this.rightIcon;
      if (showRightIcon) {
        return h("div", {
          "class": bem('right-icon'),
          "on": {
            "click": this.onClickRightIcon
          }
        }, [this.slots('right-icon') || h(_icon.default, {
          "attrs": {
            "classPrefix": this.rightIconClassPrefix || (this.rightIconZziconfont ? 'zziconfont' : undefined),
            "name": this.rightIcon
          }
        })]);
      }
    },
    genMessage: function genMessage() {
      var h = this.$createElement;
      if (this.zzForm && this.zzForm.showErrorMessage === false) {
        return;
      }
      var message = this.errorMessage || this.validateMessage;
      if (message) {
        var errorMessageAlign = this.getProp('errorMessageAlign');
        return h("div", {
          "class": bem('error-message', errorMessageAlign)
        }, [message]);
      }
    },
    genCountingWord: function genCountingWord() {
      var h = this.$createElement;
      if (this.countingWord) {
        return h("div", {
          "class": [bem("count-word-" + this.type, this.countingWord.exceeded ? 'exceeded' : undefined)]
        }, [this.countingWord.total, "/", this.countingWord.max]);
      }
    },
    getProp: function getProp(key) {
      if ((0, _utils2.isDef)(this[key])) {
        return this[key];
      }
      if (this.zzForm && (0, _utils2.isDef)(this.zzForm[key])) {
        return this.zzForm[key];
      }
    },
    genLabel: function genLabel() {
      var h = this.$createElement;
      if (this.slots('label')) {
        return this.slots('label');
      }
      if (this.label) {
        return h("span", [this.label]);
      }
    }
  },
  render: function render() {
    var _bem;
    var h = arguments[0];
    var slots = this.slots;
    var labelAlign = this.getProp('labelAlign');
    var labelWidth = this.getProp('labelWidth') || '80px';
    var scopedSlots = {
      icon: this.genLeftIcon
    };
    var withLeftIcon = slots('left-icon') || this.leftIcon;
    var maxWidth = withLeftIcon ? "calc(" + (0, _utils2.addUnit)(labelWidth) + " - 26px)" // minus icon width
    : (0, _utils2.addUnit)(labelWidth);
    var Label = this.genLabel();
    if (Label) {
      scopedSlots.title = function () {
        return Label;
      };
    }
    return h(_cell.default, {
      "attrs": {
        "center": false,
        "icon": this.leftIcon,
        "border": this.border,
        "isLink": this.isLink,
        "required": this.required,
        "clickable": this.clickable,
        "disabled": this.disabled,
        "titleStyle": {
          maxWidth: maxWidth
        },
        "titleClass": [bem('label', labelAlign), this.labelClass]
      },
      "scopedSlots": scopedSlots,
      "class": bem((_bem = {
        error: this.showError,
        disabled: this.disabled
      }, _bem["label-" + labelAlign] = labelAlign, _bem['min-height'] = this.type === 'textarea' && !this.autosize, _bem['with-button'] = slots('button'), _bem['with-counting-word'] = this.countingWord, _bem)),
      "on": {
        "click": this.onClick
      }
    }, [h("div", {
      "class": [bem('body'), this.darkBg && bem('body_darkbg')]
    }, [this.genInput(), this.showClear && h(_icon.default, {
      "attrs": {
        "classPrefix": "zziconfont",
        "name": "close-text"
      },
      "class": bem('clear'),
      "on": {
        "touchstart": this.onClear
      }
    }), this.genRightIcon(), this.type === 'text' && this.genCountingWord(), slots('button') && h("div", {
      "class": bem('button')
    }, [slots('button')])]), this.genMessage(), this.type === 'textarea' && this.genCountingWord()]);
  }
});
exports.default = _default;